import { render } from "./MessageContent.vue?vue&type=template&id=73a6e4b0&scoped=true"
import script from "./MessageContent.vue?vue&type=script&lang=js"
export * from "./MessageContent.vue?vue&type=script&lang=js"

import "./MessageContent.vue?vue&type=style&index=0&id=73a6e4b0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73a6e4b0"]])

export default __exports__